import { render, staticRenderFns } from "./MdWileyModalitytoObjectiveCN.vue?vue&type=template&id=b0f3d4c0&"
import script from "./MdWileyModalitytoObjectiveCN.vue?vue&type=script&lang=js&"
export * from "./MdWileyModalitytoObjectiveCN.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports